
































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Cookies from 'js-cookie';
import storage from 'baimahu/storage';
import { AxiosResponse } from 'axios';
const { VUE_APP_API } = process.env;
const dateFormat = require('bmh/date-format');
const API = {
  query: `${VUE_APP_API}/qy/merchant/exports/detail`, // 概况查询
  setGoal: `${VUE_APP_API}/qy/merchant/exports/setSalesAmountGoal`, // 设置月度销售额目标
  read: `${VUE_APP_API}/qy/merchant/message/read`, // 设置消息已读
  list: `${VUE_APP_API}/qy/merchant/message/listDetail`, // 消息列表
  topClerk: `${VUE_APP_API}/qy/merchant/exports/topClerk`, // 分销员排行
};
const waitDealList = [
  {
    des: '未绑定微信小程序',
    btnText: '立即绑定',
    url: '/setting/authorize',
    isShow: true,
  },
  {
    des: '未绑定支付商户号',
    btnText: '立即绑定',
    url: '/setting/payment',
    isShow: true,
  },
  {
    des: '未填写基础信息',
    btnText: '立即填写',
    url: '/setting/basic-info',
    isShow: true,
  },
  {
    des: '未保存交易设置',
    btnText: '立即保存',
    url: '/setting/trade',
    isShow: true,
  },
  {
    des: '笔订单待发货',
    btnText: '操作发货',
    url: '/order/list?status=5',
    num: 0,
  },
  {
    des: '笔待审核的提现申请',
    btnText: '审核提现',
    url: '/finance/list?index=2&status=5',
    num: 0,
  },
  {
    des: '个商品库存过少',
    btnText: '新增库存',
    url: '/ware/list?stock_range=0&stock_range=10',
    num: 0,
  },
];
const rankColumns = [
  {
    title: '排名',
    dataIndex: 'rankId',
  },
  {
    title: '分销员',
    dataIndex: 'clerkName',
  },
  {
    // title: '订单数',
    dataIndex: 'orderCount',
    slots: {
      title: 'orderCount',
    },
  },
  {
    // title: '销售额',
    dataIndex: 'money',
    slots: {
      title: 'money',
    },
  },
  {
    // title: '奖金',
    dataIndex: 'bonus',
    slots: {
      title: 'bonus',
    },
  },
];

@Component
export default class Home extends Vue {
  isLoading: boolean = false;
  isShowDetail: boolean = false;
  companyName: string = '';
  userMobile: string = '';
  updateTime: string = '';
  orderNum: number = 0;
  yesterdayOrder: number = 0;
  saleNum: number = 0;
  yesterdaySale: number = 0;
  monthSalesAmount: number = 0;
  monthSalesAmountGoal: number = 0;
  beforeEditMonthSalesAmountGoal: number = 0;
  isEditMonthSalesAmountGoal: boolean = false;
  comProgress: any = Number('0').toFixed();

  waitDealNum: number = 0;
  noReadNum: number = 0;
  waitDealList: any = waitDealList;
  selectInform: any = [];
  informList: any = [];
  informListDetail: any = [];

  rankTime: string = 'today';
  rankTimeTwo: string = 'today';
  rankColumns: any = rankColumns;
  rankTableData: any = [
    {
      rankId: '1',
      clerkName: '',
      orderCount: 0,
      money: 0,
      bonus: 0,
    },
  ];
  rankTableDataTwo: any = [
    {
      rankId: '1',
      clerkName: '',
      orderCount: 0,
      money: 0,
      bonus: 0,
    },
  ];
  isActiveHead: string = 'order_count';
  isActiveHeadTwo: string = 'order_count';
  isActiveMore: boolean = false;
  isActiveMoreTwo: boolean = false;
  isShowMore: boolean = false;
  isShowMoreTwo: boolean = false;

  clickTableHead(col: string, level: number = 1) {
    if (level === 1) {
      this.isActiveHead = col;
      this.queryRankData(1);
    } else if (level === 2) {
      this.isActiveHeadTwo = col;
      this.queryRankData(2);
    }
  }

  getMoreRankList(level: number = 1) {
    if (level === 1) {
      this.queryRankData(1);
      this.isActiveMore = !this.isActiveMore;
    } else if (level === 2) {
      this.queryRankData(2);
      this.isActiveMoreTwo = !this.isActiveMoreTwo;
    }
  }

  cancelEditGoal() {
    this.monthSalesAmountGoal = this.beforeEditMonthSalesAmountGoal;
    this.isEditMonthSalesAmountGoal = false;
  }

  clickEditGoalBtn() {
    this.beforeEditMonthSalesAmountGoal = this.monthSalesAmountGoal;
    this.isEditMonthSalesAmountGoal = true;
  }

  applyMonthSalesAmountGoal() {
    if (!this.isNumber(this.monthSalesAmountGoal)) {
      this.$message.error('请输入正确金额');
      return;
    }
    if (this.monthSalesAmountGoal < 0) {
      this.$message.error('本月销售额目标不可小于0');
      return;
    }
    const sendData = {
      sales_amount_goal: this.monthSalesAmountGoal,
      month: dateFormat(new Date().getTime(), '%Y%m'),
    };
    this.isLoading = true;
    this.$axios
      .post(API.setGoal, sendData)
      .then((res: AxiosResponse) => {
        if (res.data.error !== 0) {
          this.$message.error(res.data.message);
        } else {
          this.calProgressNum();
          this.isEditMonthSalesAmountGoal = false;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  goToDeal(url: any) {
    this.$router.push(url);
  }

  logOut() {
    storage.removeItem('profile');
    window.location.reload();
  }

  query() {
    this.isLoading = true;
    this.$axios
      .get(API.query)
      .then((res: AxiosResponse) => {
        if (res.data.error !== 0) {
          this.$message.error(res.data.message);
          return;
        }
        const data = res.data.data;
        this.updateTime = dateFormat(new Date().getTime(), '%Y-%m-%d %H:%M:%S');
        this.orderNum = data.today_order_count;
        this.yesterdayOrder = data.yesterday_order_count;
        this.saleNum = data.today_sales_amount;
        this.yesterdaySale = data.yesterday_sales_amount;
        this.monthSalesAmount = data.month_sales_amount;
        this.monthSalesAmountGoal = data.month_sales_amount_goal;
        this.calProgressNum();
        const info = data.complete_degree;
        this.waitDealList[0].isShow = info.bind_wx_app === 0;
        this.waitDealList[1].isShow = info.bind_pay === 0;
        this.waitDealList[2].isShow = info.bind_base === 0;
        this.waitDealList[3].isShow = info.bind_trade === 0;
        this.waitDealList[4].num = data.waiting_delivered_count;
        this.waitDealList[5].num = data.waiting_check_count;
        this.waitDealList[6].num = data.few_stock_ware_count;
        this.calWaitDealNum();
        this.informList = data.message.map((item: any) => {
          item.time = item.notify_time;
          item.isRead = item.read === 1;
          return item;
        });
        this.noReadNum = data.message_unread_count;
        this.queryRankData(1);
        this.queryRankData(2);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  async created() {
    const profile = storage.getItem('profile') || {};
    const userInfo = profile;
    this.companyName = profile.name || '';
    this.userMobile = profile.mobile || '';
    this.query();
  }

  changeSelect(level: number = 1) {
    if (level === 1) {
      this.queryRankData(1);
    } else if (level === 2) {
      this.queryRankData(2);
    }
  }

  async queryRankData(level: number = 1) {
    this.isLoading = true;
    let sort = '';
    let time = '';
    if (level === 1) {
      if (this.isActiveHead === '') {
        sort = 'order_count';
      } else {
        sort = this.isActiveHead;
      }
      time = this.rankTime;
    } else if (level === 2) {
      if (this.isActiveHeadTwo === '') {
        sort = 'order_count';
      } else {
        sort = this.isActiveHeadTwo;
      }
      time = this.rankTimeTwo;
    }
    this.$axios
      .get(`${API.topClerk}?time_type=${time}&sort=${sort}&level=${level}`)
      .then((res: AxiosResponse) => {
        if (res.data.error === 0) {
          const data = res.data.data;
          if (level === 1) {
            this.rankTableData = data.map((item: any, index: any) => {
              item.rankId = index + 1;
              item.clerkName = item.clerk_name;
              item.orderCount = item.order_count;
              return item;
            });
            if (this.rankTableData.length > 10) {
              this.isShowMore = true;
            } else {
              this.isShowMore = false;
            }
            if (!this.isActiveMore) {
              this.rankTableData = this.rankTableData.slice(0, 9);
            }
          } else if (level === 2) {
            this.rankTableDataTwo = data.map((item: any, index: any) => {
              item.rankId = index + 1;
              item.clerkName = item.clerk_name;
              item.orderCount = item.order_count;
              return item;
            });
            if (this.rankTableDataTwo.length > 10) {
              this.isShowMoreTwo = true;
            } else {
              this.isShowMoreTwo = false;
            }
            if (!this.isActiveMoreTwo) {
              this.rankTableDataTwo = this.rankTableDataTwo.slice(0, 9);
            }
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  allInform() {
    this.isShowDetail = true;
    this.isLoading = true;
    this.$axios
      .get(API.list)
      .then((res: AxiosResponse) => {
        if (res.data.error === 0) {
          const data = res.data.data;
          this.informListDetail = data;
        }
      })
      .finally(() => {
        this.isLoading = false;
        this.$axios.get(API.read);
      });
  }

  backHome() {
    this.isShowDetail = false;
    this.query();
  }

  calWaitDealNum() {
    this.waitDealNum = 0;
    for (let i = 0; i < this.waitDealList.length; i++) {
      if (i < 4) {
        if (this.waitDealList[i].isShow) {
          this.waitDealNum++;
        }
      } else {
        if (this.waitDealList[i].num > 0) {
          this.waitDealNum++;
        }
      }
    }
  }

  calProgressNum() {
    // 计算进度
    if (Number(this.monthSalesAmountGoal) === 0) {
      this.comProgress = Number('0').toFixed(2);
    } else {
      this.comProgress = (
        Math.round(
          (this.monthSalesAmount / this.monthSalesAmountGoal) * 10000,
        ) / 100
      ).toFixed(2);
    }
  }

  isNumber(val: any) {
    // 判断是否为数字
    if (val === '' || val === null) {
      return false;
    }
    if (!isNaN(val)) {
      return true;
    } else {
      return false;
    }
  }

  readMessage(item: any) {
    if (!item.isRead) {
      this.noReadNum--;
      item.isRead = true;
      const sendData = {
        message_id: item.id,
      };
      this.$axios.post(API.read, sendData);
    }
  }
}
